// app/javascript/bundles/company/document_defaults/page_library/bulk_results.tsx
import React from 'react';

import { Alert } from 'components/ui/alert';
import { pluralize } from 'helpers/formatters/string_formats';

import { BulkStatus, pageKey, type BulkResult } from './types';

interface Props {
  // Past-tense phrase completing "{n} pages …", e.g. "added to 2 documents".
  verb: string;
  results: BulkResult[];
}

const severityFor = (done: number, skipped: number) => {
  if (done === 0) return 'destructive';
  if (skipped > 0) return 'warning';

  return 'success';
};

const labelFor = (result: BulkResult) => result.name ?? `Page ${result.pageId}`;

export default function BulkResults({ verb, results }: Props) {
  if (results.length === 0) return null;

  const done = results.filter(r => r.status === BulkStatus.Done).length;
  const skipped = results.filter(r => r.status === BulkStatus.Skipped);
  const severity = severityFor(done, skipped.length);

  return (
    <Alert className="mb-3" severity={severity}>
      <Alert.Title>{pluralize(done, 'page')} {verb}.</Alert.Title>
      {skipped.length > 0 && (
        <ul className="mb-0 mt-2">
          {skipped.map(result => (
            <li key={pageKey(result.pageType, result.pageId)}>
              Skipped {labelFor(result)}: {result.reason}
            </li>
          ))}
        </ul>
      )}
    </Alert>
  );
}
